import { useEffect, useRef, FC } from "react";
import { Mode, State } from "../../services/zodiacEngine/types";

interface TurnPopoverProps {
  isThisPlayersTurn: boolean;
  mode: Mode;
  state: State;
  duration?: number;
}

const TurnPopover: FC<TurnPopoverProps> = ({
  isThisPlayersTurn,
  mode,
  state,
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const turnChangeStates = [State.PieceSelection, State.Playing];

  useEffect(() => {
    // Create audio element on component mount
    if (!audioRef.current) {
      audioRef.current = new Audio("/turn change.mp3");
      audioRef.current.volume = 0.5; // Set to medium volume
    }

    // Play sound when it becomes the player's turn in any game mode with opponents
    if (
      isThisPlayersTurn &&
      (mode === Mode.Live || mode === Mode.AI) && // Includes ChallengeAI which uses Mode.AI
      turnChangeStates.includes(state)
    ) {
      // Play the sound when it becomes the player's turn (opponent just moved)
      if (audioRef.current) {
        audioRef.current.currentTime = 0; // Reset to beginning in case it was already playing
        audioRef.current.play().catch(error => {
        });
      }
    }
    
    // Clean up on unmount
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [isThisPlayersTurn, mode, state]);

  // No visual component to render
  return null;
};

export default TurnPopover;
